import { API } from '../../config/apiBase';

/**
 * Uma requisição de `/api/promotions/home` por visita, compartilhada.
 *
 * Dois componentes precisam dessa resposta: o hero, para saber se existe
 * campanha ativa e sair de cena, e a Central, que desenha os blocos. Sem este
 * cache a Home faria a mesma chamada duas vezes na mesma dobra.
 *
 * Só é chamado com a flag `promotions_hub` ligada. Com a flag desligada nenhum
 * dos dois componentes toca nesta função.
 */
let emVoo = null;

const previewCentral = () => process.env.NODE_ENV !== 'production'
    && typeof window !== 'undefined'
    && (new URLSearchParams(window.location.search).get('preview') || '').startsWith('central');

export function carregarPromocoesHome({ forcar = false } = {}) {
    if (emVoo && !forcar) return emVoo;
    emVoo = previewCentral()
        ? montarPreviewDesenvolvimento()
        : fetch(`${API}/promotions/home`)
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null);
    return emVoo;
}

// Só para testes.
export function _limparCachePromocoes() { emVoo = null; }

/**
 * DADOS DE PREVIEW, SÓ EM DESENVOLVIMENTO (`?preview=central`).
 *
 * Existe para avaliar o visual da Central com ela desligada em produção. O build
 * de produção elimina este caminho: `process.env.NODE_ENV` vira a string
 * 'production' e o ramo inteiro some.
 *
 * Nada aqui é gravado. As campanhas são texto de exemplo; os produtos das ofertas
 * relâmpago são deals reais de agora, com um fim de promoção fictício aplicado
 * só nesta tela.
 */
async function montarPreviewDesenvolvimento() {
    const agora = Date.now();
    const emHoras = (h) => new Date(agora + h * 3600 * 1000).toISOString();
    let reais = [];
    try {
        const r = await fetch(`${API}/produtos?sort=discount&limit=6`);
        reais = (await r.json()).deals || [];
    } catch (_) { reais = []; }

    // `?preview=central-sem-imagem` põe a campanha sem arte na frente, para ver o
    // fallback; `?preview=central`, a campanha com imagem.
    const semImagemPrimeiro = new URLSearchParams(window.location.search).get('preview') === 'central-sem-imagem';
    const campanhas = [
        {
            campaign_id: 'preview_1', title: 'Semana dos achados de casa',
            subtitle: 'Utilidades, organização e cozinha com os maiores descontos da semana.',
            marketplace: 'shopee', marketplace_name: 'Shopee', banner_image: '',
            ends_at: emHoras(30), show_countdown: true, target_url: '/busca?marketplace=shopee', status: 'active',
        },
        {
            campaign_id: 'preview_2', title: 'Tecnologia com preço de verdade',
            subtitle: 'Fones, carregadores e acessórios do Mercado Livre selecionados hoje.',
            marketplace: 'mercadolivre', marketplace_name: 'Mercado Livre',
            banner_image: reais[1]?.image_url || '', ends_at: null, show_countdown: false,
            target_url: '/busca?marketplace=mercadolivre', status: 'active',
        },
    ];
    if (!semImagemPrimeiro) campanhas.reverse();

    return {
        campaigns: campanhas,
        stores: [
            { marketplace: 'mercadolivre', name: 'Mercado Livre', deals_count: 3965, campaigns_count: 1, best_discount: 80, url: '/busca?marketplace=mercadolivre' },
            { marketplace: 'shopee', name: 'Shopee', deals_count: 2436, campaigns_count: 1, best_discount: 98, url: '/busca?marketplace=shopee' },
            { marketplace: 'amazon', name: 'Amazon Brasil', deals_count: 157, campaigns_count: 0, best_discount: 95, url: '/busca?marketplace=amazon' },
            { marketplace: 'magalu', name: 'Magazine Luiza', deals_count: 1, campaigns_count: 0, best_discount: 33, url: '/busca?marketplace=magalu' },
        ],
        flash_deals: reais.slice(0, 5).map((d, i) => ({
            deal_id: d.deal_id, title: d.title, image_url: d.image_url,
            current_price: d.current_price, original_price: d.original_price,
            discount_percent: d.discount_percent, store_name: d.store_name,
            promo_ends_at: emHoras(2 + i * 3), url: `/oferta/${d.deal_id}`,
        })),
        counts: {},
    };
}
